import { patientDeleteTask, schedulingTask, skillListConstant } from './constant';

const { GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST } = skillListConstant;
const { DELETE_PATIENT_TASK_REQUEST, RESET_DELETE_PATIENT_TASK } = patientDeleteTask;
const {
  CREATE_TASK_NOTE_SCHEDULING_REQUEST,
  GET_TASK_NOTE_SCHEDULING_REQUEST,
  CREATE_TASK_NOTE_SCHEDULING_RESET,
  GET_TASK_NOTE_SCHEDULING_RESET,
  DELETE_TASK_NOTE_SCHEDULING_REQUEST,
  DELETE_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

export const getTherapistSkillList = (payload: object) => {
  return {
    type: GET_SKILL_THERAPIST_SCHEDULING_LIST_REQUEST,
    payload,
  };
};

export const deletePatientTask = (payload: object) => {
  return {
    type: DELETE_PATIENT_TASK_REQUEST,
    payload,
  };
};
export const resetDeletePatientTask = () => {
  return {
    type: RESET_DELETE_PATIENT_TASK,
  };
};

export const getTherapistTaskNoteAction = (payload: any) => {
  return {
    type: GET_TASK_NOTE_SCHEDULING_REQUEST,
    payload,
  };
};

export const createTherapistTaskNoteAction = (payload: any) => {
  return {
    type: CREATE_TASK_NOTE_SCHEDULING_REQUEST,
    payload,
  };
};

export const resetGetTherapistTaskNote = () => {
  return {
    type: GET_TASK_NOTE_SCHEDULING_RESET,
  };
};

export const resetCreateTherapistTaskNote = () => {
  return {
    type: CREATE_TASK_NOTE_SCHEDULING_RESET,
  };
};

export const deleteTherapistTaskNoteAction = (payload: any) => {
  return {
    type: DELETE_TASK_NOTE_SCHEDULING_REQUEST,
    payload,
  };
};

export const resetDeleteTherapistTaskNote = () => {
  return {
    type: DELETE_TASK_NOTE_SCHEDULING_RESET,
  };
};
